import React from 'react';

const SvgBy = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BY_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BY_svg__b" fill="#fff">
        <use xlinkHref="#BY_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BY_svg__a" />
      <path fill="#E54252" mask="url(#BY_svg__b)" d="M0 0h28v13.333H0z" />
      <path fill="#5CBE6B" mask="url(#BY_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        d="M4 17v3H0V0h4v3l-.667 1L4 5v2l-.667 1L4 9v2l-.667 1L4 13v2l-.667 1L4 17z"
        fill="#FFF"
        mask="url(#BY_svg__b)"
      />
      <path
        d="M-2 4l1.333-2L.667 4-.667 6-2 4zm0 4l1.333-2L.667 8l-1.334 2L-2 8zm0 4l1.333-2 1.334 2-1.334 2L-2 12zm0 4l1.333-2 1.334 2-1.334 2L-2 16zM.667 2L2 0l1.333 2L2 4 .667 2zm0 4L2 4l1.333 2L2 8 .667 6zm0 4L2 8l1.333 2L2 12 .667 10zm0 4L2 12l1.333 2L2 16 .667 14zm0 4L2 16l1.333 2L2 20 .667 18z"
        fill="#E54252"
        mask="url(#BY_svg__b)"
      />
    </g>
  </svg>
);

export default SvgBy;
